import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Breadcrumb, BreadcrumbHome, BreadcrumbItem, Text} from "@wfp/ui";
import {LossList} from "../components/loss/list";

export default function Losses() {
    const {t} = useTranslation();

    return (
        <>
            <div className="visible md:hidden">
                <div className="m-5 flex">
                    <div className="ml-0 text-center">
                        <Text kind='h1'>{t("loss_management")}</Text>
                    </div>
                </div>
            </div>
            <div className="hidden md:block">
                <div className="m-10">
                    <Breadcrumb className="mb-5">
                        <BreadcrumbItem>
                            <NavLink to="/"><BreadcrumbHome/></NavLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem disableLink>
                            {t('losses')}
                        </BreadcrumbItem>
                    </Breadcrumb>
                    <div className="text-left mb-5">
                        <Text kind='h1' className="">{t("loss_management")}</Text>
                    </div>
                    <LossList/>
                </div>
            </div>
        </>
    );
}
